import { createModel } from "@rematch/core";
import { HousingSituationsState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, signoutIfUnauthorized } from "./utilities";

const initialState: HousingSituationsState = {
  buildingTypes: [],
  buildingAges: [],
};

export const housingSituations = createModel<RootModel>()({
  state: initialState as HousingSituationsState,
  reducers: {
    fetchSuccess(state, payload: HousingSituationsState) {
      return payload;
    },
    fetchFail(state) {
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async fetchHousingSituations(payload: null, rootState) {
      const token = checkToken(rootState, () =>
        dispatch.housingSituations.fetchFail()
      );
      if (!token) return;

      try {
        const housingSituationsResult = await api.fetchHousingSituations(token);
        dispatch.housingSituations.fetchSuccess(housingSituationsResult.data);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.housingSituations.fetchFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/housingSituations.ts